import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求标签组列表
export const getlabelDadList = params => {
    return get("/admin/tagGroup", params);
};

// 修改信息
export const editlabelDad = params => {
    return put(`/admin/tagGroup/${params.id}`, params);
};

// 添加标签组
export const addlabelDad = params => {
    return post("/admin/tagGroup", params);
};

// 删除标签组
export const deletelabelDad = params => {
    return del(`/admin/tagGroup/${params}`);
};

// 获取标签类型
export const tagType = params => {
    return get('/admin/tagType', params);
};


// WEBPACK FOOTER //
// ./src/api/labelParent.js